import { render } from "./WeaponOwnList.vue?vue&type=template&id=4c7e45c8&scoped=true&ts=true"
import script from "./WeaponOwnList.vue?vue&type=script&lang=ts"
export * from "./WeaponOwnList.vue?vue&type=script&lang=ts"

import "./WeaponOwnList.vue?vue&type=style&index=0&id=4c7e45c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7e45c8"]])

export default __exports__